import { http } from "@/commons/utils/axios-instances"
import type { OrganizationSchemaType } from "@/marketplace/typings/organization"

export const fetchInvoiceDetails = () =>
  http.get<OrganizationSchemaType>("/me/organization").then((res) => res.data)

export const callSaveInvoiceDetails = (data: OrganizationSchemaType) =>
  http.post<OrganizationSchemaType>("/me/organization", data).then((res) => res.data)
